import React from 'react'
import './Backgound.css'

export default class Background extends React.Component {

  static defaultProps = {
    pandaStyle:{},
    hideTitle:false
  }

  render () {
    const { pandaStyle, hideTitle } = this.props
    return (
      <div className="background-fixed" >
        <div className="backgound-container" >
          <img src={require('../svgs/panda.svg')} className="background-panda"
            style={{ ...pandaStyle }}  />
          <img src={require('../svgs/logo.png')} className="background-logo"  />
          {!hideTitle && <img src={require('../svgs/title.svg')} className="background-title" />}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Background/index.js